import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex } from '@chakra-ui/react';
import { Button, Icon, SearchIcon } from '@whitbread-eos/atoms';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import LocationPicker from '../LocationPicker';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FIELDS = {
  location: 'location'
};
export default function SearchPriceFinder(_ref) {
  var router = _ref.router,
    defaultLocation = _ref.defaultLocation,
    partialTranslations = _ref.partialTranslations,
    AEMTranslations = _ref.AEMTranslations,
    screenSize = _ref.screenSize,
    suggestions = _ref.suggestions,
    onIsSearchActive = _ref.onIsSearchActive,
    onLocationInputChange = _ref.onLocationInputChange,
    onLocationInputClear = _ref.onLocationInputClear,
    onLocationInputFocus = _ref.onLocationInputFocus,
    searchPriceFinderStyles = _ref.searchPriceFinderStyles,
    errorField = _ref.errorField,
    errorMessage = _ref.errorMessage,
    _ref$searchDisabled = _ref.searchDisabled,
    searchDisabled = _ref$searchDisabled === void 0 ? false : _ref$searchDisabled,
    handleLocationSearch = _ref.handleLocationSearch,
    setLocationName = _ref.setLocationName;
  var isLessThanLg = screenSize.isLessThanLg,
    isLessThanMd = screenSize.isLessThanMd,
    isLessThanSm = screenSize.isLessThanSm;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    location = _useState2[0],
    setLocation = _useState2[1];
  var _router$query = router.query,
    PLACEID = _router$query.PLACEID,
    searchTerm = _router$query.searchTerm;
  var searchParams = useSearchParams();
  var searchWrapper = searchPriceFinderStyles.searchWrapper,
    locationPickerStyles = searchPriceFinderStyles.locationPickerStyles,
    inputGroupStyles = searchPriceFinderStyles.inputGroupStyles,
    inputElementStyles = searchPriceFinderStyles.inputElementStyles,
    errorInputGroupStyles = searchPriceFinderStyles.errorInputGroupStyles,
    errorInputElementStyles = searchPriceFinderStyles.errorInputElementStyles,
    errorMarginBottom = searchPriceFinderStyles.errorMarginBottom,
    buttonStyles = searchPriceFinderStyles.buttonStyles;
  var autocompleteStyles = _objectSpread({
    locationPickerStyles,
    inputGroupStyles,
    inputElementStyles,
    errorMarginBottom
  }, errorField === FIELDS.location && {
    errorInputGroupStyles,
    errorInputElementStyles
  });
  var handleOnClick = () => {
    if (handleLocationSearch && setLocationName && location && 'placeId' in location) {
      handleLocationSearch(location.placeId);
      setLocationName(location === null || location === void 0 ? void 0 : location.suggestion);
      if (PLACEID && searchTerm) {
        updateQueryParams({
          PLACEID: location.placeId,
          searchTerm: location === null || location === void 0 ? void 0 : location.suggestion
        }, searchParams, router);
      }
      window.__satelliteLoaded && window._satellite.track('priceFinderHotelSelected');
    }
  };
  return _jsx(Flex, {
    direction: "column",
    alignItems: "center",
    children: _jsxs(Flex, _objectSpread(_objectSpread({
      align: "center",
      bgColor: "baseWhite"
    }, searchWrapper), {}, {
      "data-testid": "search-component",
      onFocus: () => {
        if (onIsSearchActive) {
          onIsSearchActive(true);
        }
      },
      children: [_jsx(LocationPicker, _objectSpread(_objectSpread({}, locationPickerStyles), {}, {
        inputPlaceholder: AEMTranslations.priceFinderLocationPlaceholder || getLocationPlaceholder(),
        defaultInputValue: defaultLocation || searchTerm,
        isLocationRequired: true,
        hasListDivider: false,
        styles: autocompleteStyles,
        onSelectLocation: handleSelectLocation,
        suggestions: suggestions,
        onInputChange: onLocationInputChange,
        onInputClear: onLocationInputClear,
        onInputFocus: onLocationInputFocus,
        isPriceFinder: true
      }, errorField === FIELDS.location && {
        showErrorMessage: true,
        errorMessage: errorMessage
      })), _jsx(Button, _objectSpread(_objectSpread({
        zIndex: 10,
        size: "md",
        variant: "primary",
        name: "search-button",
        "data-testid": "search-component-button",
        isDisabled: searchDisabled
      }, buttonStyles), {}, {
        mt: {
          base: '0',
          sm: '0'
        },
        onClick: handleOnClick,
        children: getButtonContent()
      }))]
    }))
  });
  function handleSelectLocation(location) {
    setLocation(location);
  }
  function getLocationPlaceholder() {
    var _partialTranslations$;
    return isLessThanLg && !isLessThanSm ? AEMTranslations.locationPlaceholder : partialTranslations === null || partialTranslations === void 0 || (_partialTranslations$ = partialTranslations.form) === null || _partialTranslations$ === void 0 ? void 0 : _partialTranslations$.where;
  }
  function getButtonContent() {
    return isLessThanMd ? _jsx(Icon, {
      svg: _jsx(SearchIcon, {
        color: "var(--chakra-colors-baseWhite)"
      })
    }) : AEMTranslations.submitButtonLabel;
  }
}
export var updateQueryParams = (newParams, searchParams, router) => {
  var _searchParams$toStrin, _searchParams$toStrin2;
  var params = new URLSearchParams((_searchParams$toStrin = searchParams === null || searchParams === void 0 || (_searchParams$toStrin2 = searchParams.toString) === null || _searchParams$toStrin2 === void 0 ? void 0 : _searchParams$toStrin2.call(searchParams)) !== null && _searchParams$toStrin !== void 0 ? _searchParams$toStrin : '');
  Object.entries(newParams).forEach(_ref2 => {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    if (value === null || value === undefined || value === '') {
      params.delete(key);
    } else {
      params.set(key, String(value));
    }
  });
  router.push("".concat(window.location.pathname, "?").concat(params.toString()));
};